import React, {Component} from 'react';
import {FormGroup,} from 'reactstrap';
import Checkbox from "../../../../shared/forms/Checkbox";

class CheckoffResponse extends Component {
  // ----------------------
  // Lifecycle
  // ----------------------

  componentWillMount() {
    // Validate for case of edit
    if (this.props.value.isChecked) {
      this.props.onValueChange(this.props.name, { isChecked: true, isValid: true });
    } else if(this.props.isNotRequired) {
      this.props.onValueChange(this.props.name, { isChecked: false, isValid: true });
    }
  }

  // ----------------------
  // Methods
  // ----------------------

  handleInput() {
    const valueObject = !this.props.value.isChecked
      ? { isChecked: true, isValid: true }
      : { isChecked: false, isValid: !!this.props.isNotRequired };

    this.props.onValueChange(this.props.name, valueObject);
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <div>
        <label>
          {this.props.prompt}
        </label>
          <FormGroup>
            <Checkbox
              checked={this.props.value.isChecked}
              name={this.props.name}
              onChange={() => this.handleInput()}
              label={this.props.checkoffPrompt || "I Agree"}/>
          </FormGroup>
      </div>
    );
  }
}

export default CheckoffResponse;

